import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Inject } from "@angular/core";
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
} from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

export interface DialogData {
  animal: "panda" | "unicorn" | "lion";
}
// import { UserResponseModel } from "src/app/model/UserResponseModel";
import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { AppointmentSlotModel } from "src/app/model/AppointmentSlotModel";
import { TimePickerComponent } from "../timePikker/time-picker.component";

@Component({
  selector: "app-secure-user-au",
  templateUrl: "./open-appointment-slot.component.html",
  styleUrls: ["./open-appointment-slot.component.scss"],
})
export class OpenAppointmentSlot implements OnInit {
  appointmentKey: number;
  pageMode: string;
  // userModel : UserResponseModel;
  userModel: AppointmentSlotModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  roles: { [key: number]: string };
  boards: { [key: number]: string };
  boardWiseDepartments: { [key: number]: { [key: number]: string } };
  departmentWiseDesignations: { [key: number]: { [key: number]: string } };
  tomorrowDate: string;
  slotStartTimeControl = new FormControl();
  slotEndTimeControl = new FormControl();
  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private datePipe: DatePipe,
  ) {
    const currentDate = new Date();
    const tomorrow = new Date(currentDate);
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.tomorrowDate = this.datePipe.transform(tomorrow, "yyyy-MM-dd");
  }

  ngOnInit() {
    this.form = new FormGroup({
      userResponsibilityLst: new FormArray([]),
      appointmentDate: new FormControl(null, []),
    });
    this.masterService.initUserForm().subscribe((data: any) => {
      if (data.status === "SUCCESS") {
        this.roles = data.roles;
        this.boards = data.boards;
        this.boardWiseDepartments = data.boardWiseDepartments;
        this.departmentWiseDesignations = data.departmentWiseDesignations;

        this.route.params.subscribe((params: Params) => {
          this.appointmentKey = +params["key"];
          if (this.appointmentKey) {
            this.masterService
              .getAppointmentByKey(this.appointmentKey)
              .subscribe((data: any) => {
                this.userModel = data;
                this.pageMode = "Edit";
                this.form.patchValue({
                  appointmentDate: this.userModel.appointmentDate,
                });
                let selectedUserResponsibilityLst: FormArray = this.form.get(
                  "userResponsibilityLst"
                ) as FormArray;

                selectedUserResponsibilityLst.clear();
                this.userModel.slots.forEach((ur) => {
                  selectedUserResponsibilityLst.push(
                    new FormGroup({
                      key: new FormControl(ur.key),
                      slotStartTimeControl: new FormControl(
                        ur.slotStartTime,
                        Validators.required
                      ),
                      slotEndTimeControl: new FormControl(
                        ur.slotEndTime,
                        Validators.required
                      ),
                      // applicantCount: new FormControl(
                      //   ur.applicantCount,
                      //   Validators.required
                      // ),
                    })
                  );
                });
              });
          } else {
            this.pageMode = "Add";
          }
        });
      } else {
        this.errorToast(data.errorMessage, 5 * 1000);
      }
    });

    let userResponsibilityLst: FormArray = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;
    userResponsibilityLst.push(
      new FormGroup({
        key: new FormControl(null),
        slotStartTimeControl: new FormControl(null),
        slotEndTimeControl: new FormControl(null),
        // applicantCount: new FormControl(null),
      })
    );
  }

  openStartTimePicker(index: number) {
    const dialogRef = this.dialog.open(TimePickerComponent, {
      panelClass: "no-padding-dialog",
    });

    dialogRef.componentInstance.timeSelected.subscribe((selectedTime: any) => {
      const formattedTime = `${selectedTime.hour}:${selectedTime.minute}${selectedTime.ampm}`;

      const userResponsibilityLst = this.form.get(
        "userResponsibilityLst"
      ) as FormArray;
      const selectedFormGroup = userResponsibilityLst.at(index) as FormGroup;

      selectedFormGroup.get("slotStartTimeControl").setValue(formattedTime); // Ensure correct control is set

      this.dialog.closeAll();
    });
  }
  openEndTimePicker(index: number) {
    const dialogRef = this.dialog.open(TimePickerComponent);

    dialogRef.componentInstance.timeSelected.subscribe((selectedTime: any) => {
      const formattedTime = `${selectedTime.hour}:${selectedTime.minute}${selectedTime.ampm}`;
      const userResponsibilityLst = this.form.get(
        "userResponsibilityLst"
      ) as FormArray;
      const selectedFormGroup = userResponsibilityLst.at(index) as FormGroup;

      selectedFormGroup.get("slotEndTimeControl").setValue(formattedTime); // Ensure correct control is set

      this.dialog.closeAll();
    });
  }

  onSubmit() {
    // if (this.form.valid) {
    if (this.pageMode === "Add") {
      this.save();
    } else {
      this.update();
    }
    this.errorToast;
    // } else {
    //   this.isSubmitDisabled = false;
    // }
  }

   formatDateToYYYYMMDD(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  async save() {
    if (this.allRowsFilled()) {
      if (this.form.value.appointmentDate != null) {
        let isSlotValid = true;
  
        this.form.value.userResponsibilityLst.forEach((ur) => {
          const startTime = ur.slotStartTimeControl;
          const endTime = ur.slotEndTimeControl;
  
          if (startTime >= endTime) {
            this.errorToast(
              `Slot Start Time ${startTime} must be less than Slot End Time ${endTime}`
            );
            this.isSubmitDisabled = false;
            isSlotValid = false;
          }
        });
  
        if (!isSlotValid) {
          return;
        }
  
        alert("Are you sure?");
        const appointmentDate = this.form.value.appointmentDate;
  
        this.masterService
          .saveSlotOpening({
            appointmentDate: this.formatDateToYYYYMMDD(appointmentDate),
            slots: this.form.value.userResponsibilityLst.map((ur) => ({
              key: ur.key,
              slotStartTime: ur.slotStartTimeControl,
              slotEndTime: ur.slotEndTimeControl,
            //  applicantCount: ur.applicantCount,
            })),
          })
          .subscribe(
            (data: any) => {
              if (data.status === "SUCCESS") {
                this.successToast();
                this.router.navigate([
                  "/secure",
                  "open-appintment-slot",
                  "table",
                ]);
              } else {
                this.isSubmitDisabled = false;
                this.errorToast(data.errorMessage);
              }
            },
            (error) => {
              this.isSubmitDisabled = false;
              console.log(error);
              this.errorToast(error.error.errorMessage, 5 * 1000);
            }
          );
      } else {
        this.errorToast("Please select Appointment Date");
      }
    } else {
      if (this.form.value.userResponsibilityLst.length === 0) {
        this.errorToast("Please Add Atleast One Slot Time Detail");
      } else {
        this.errorToast("Please Fill in All Required Slot Time Details");
      }
      this.isSubmitDisabled = false;
    }
  }
  
  async update() {
    if (this.allRowsFilled()) {
      if (this.form.value.appointmentDate != null) {
        let isSlotValid = true;
  
        this.form.value.userResponsibilityLst.forEach((ur) => {
          const startTime = ur.slotStartTimeControl;
          const endTime = ur.slotEndTimeControl;
  
          if (startTime >= endTime) {
            this.errorToast(
              `Slot Start Time ${startTime} must be less than Slot End Time ${endTime}`
            );
            this.isSubmitDisabled = false;
            isSlotValid = false;
          }
        });
  
        if (!isSlotValid) {
          return;
        }
  
        alert("Are you sure?");
        const appointmentDate = this.form.value.appointmentDate;
  
        this.masterService
          .updateSlotOpening(this.appointmentKey, {
            appointmentDate: this.formatDateToYYYYMMDD(appointmentDate),
            slots: this.form.value.userResponsibilityLst.map((ur) => ({
              key: ur.key,
              slotStartTime: ur.slotStartTimeControl,
              slotEndTime: ur.slotEndTimeControl,
             // applicantCount: ur.applicantCount,
            })),
          })
          .subscribe(
            (data: any) => {
              if (data.status === "SUCCESS") {
                this.successToast();
                this.router.navigate([
                  "/secure",
                  "open-appintment-slot",
                  "table",
                ]);
              } else {
                this.isSubmitDisabled = false;
                this.errorToast(data.errorMessage);
              }
            },
            (error) => {
              this.isSubmitDisabled = false;
              console.log(error);
              this.errorToast(error.error.errorMessage, 5 * 1000);
            }
          );
      } else {
        this.errorToast("Please select Appointment Date");
      }
    } else {
      if (this.form.value.userResponsibilityLst.length === 0) {
        this.errorToast("Please Add Atleast One Slot Time Detail");
      } else {
        this.errorToast("Please Fill in All Required Slot Time Details");
      }
      this.isSubmitDisabled = false;
    }
  }

  allRowsFilled(): boolean {
    const selectedUserResponsibilityLst: FormArray = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;

    let atLeastOneRowFilled = false;
    let hasEmptyRow = false;
    for (const control of selectedUserResponsibilityLst.controls) {
      if (
        control.get("slotStartTimeControl").value !== null &&
        control.get("slotEndTimeControl").value !== null 
        // &&
        // control.get("applicantCount").value !== null
      ) {
        atLeastOneRowFilled = true;
        this.isSubmitDisabled = false;
      }

      if (
        !(
          control.get("slotStartTimeControl").value &&
          control.get("slotEndTimeControl").value 
          // &&
          // control.get("applicantCount").value
        )
      ) {
        return false;
      }
    }
    return atLeastOneRowFilled;
  }

  async successToast() {
    await this._snackBar.open("User saved successfully.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  
  deleteResponsibility(i: number) {
    let selectedUserResponsibilityLst: FormArray = this.form.get(
      "userResponsibilityLst"
    ) as FormArray;
    selectedUserResponsibilityLst.removeAt(i);
  }

  get responsibilities() {
    return this.form.get("userResponsibilityLst")["controls"];
  }
  restrictInput(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.keyCode);
    if (!/^\d+$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  addResponsibility() {
  const userResponsibilityLst = this.form.get("userResponsibilityLst") as FormArray;
  userResponsibilityLst.push(
    new FormGroup({
      key: new FormControl(null),
      slotStartTimeControl: new FormControl(null, Validators.required),
      slotEndTimeControl: new FormControl(null, Validators.required),
      // applicantCount: new FormControl(null), // if needed in future
    })
  );
}

}
